import { render, staticRenderFns } from "./RightArrowSvg.vue?vue&type=template&id=de2cefc2"
import script from "./RightArrowSvg.vue?vue&type=script&lang=js"
export * from "./RightArrowSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports